import { InputField } from 'components'
import { LOCATION_TYPE_FORM_OPTIONS, LOCATION_TYPE_VALUES } from 'domains/bnk-warehouse-location/constants/location-type-labels'
import bnkWarehouseLocationCreateSchema from './bnk-warehouse-location-create-schema'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { Button } from 'reactstrap'

const propTypes = {
  handleSubmit  : PropTypes.func.isRequired,
  initialValues : PropTypes.object,
  submitLabel   : PropTypes.string
}

const BnkWarehouseLocationCreateForm = ({
  handleSubmit,
  initialValues = {
    name      : '',
    type_name : LOCATION_TYPE_VALUES.ITEM,
    active    : true
  },
  submitLabel = 'Create Product Location'
}) => (
  <Formik
    initialValues={ initialValues }
    enableReinitialize={ true }
    validationSchema={ bnkWarehouseLocationCreateSchema }
    onSubmit={ (values, formikBag) => handleSubmit(values, formikBag) }
  >
    {
      (formikBag) => (
        <Form>
          <InputField
            type="text"
            label="name"
            name="name"
            required={ true }
          />
          <InputField
            type='select'
            label='type name'
            name='type_name'
            required={ true }
          >
            {
              LOCATION_TYPE_FORM_OPTIONS.map((option) => (
                <option key={ option.key } value={ option.key }>{ option.label }</option>
              ))
            }
          </InputField>
          <InputField
            type='select'
            label='active'
            name='active'
            required={ true }
          >
            <option value={ true }>{ 'Active' }</option>
            <option value={ false }>{ 'Inactive' }</option>
          </InputField>
          <Button
            color='primary'
            disabled={ formikBag.isSubmitting }
            type="submit"
          >
            {
              formikBag.isSubmitting
                ? <i className="ni ni-settings-gear-65 spin"/>
                : submitLabel
            }
          </Button>
        </Form>
      )
    }
  </Formik>
)

BnkWarehouseLocationCreateForm.propTypes = propTypes

export default BnkWarehouseLocationCreateForm
